import React, { ChangeEvent, createRef, ReactElement, RefObject } from 'react'
import { getFileErrorMessage } from '../../services/utils'
import { IUploadButton } from '../../interfaces/Upload'

function UploadButton({
  updateFiles,
  index,
  updateFileErrors,
  isMultifile,
}: IUploadButton): ReactElement {
  const inputFileRef: RefObject<HTMLInputElement> = createRef()
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target
    if (!files) {
      return
    }
    const errorMessage = getFileErrorMessage(files[0], isMultifile)
    updateFileErrors(errorMessage, index)
    if (!errorMessage) {
      updateFiles(files[0], index)
    }
  }

  return (
    <>
      <input
        type="file"
        ref={inputFileRef}
        name="upload"
        onChange={handleChange}
        className="hidden"
        accept="application/pdf, image/jpeg, image/png"
        data-testid={`uploadInput${index}`}
      />
      <button
        className="btn btnUpload wFull wAutoSm"
        type="button"
        onClick={() =>
          inputFileRef && inputFileRef.current && inputFileRef.current.click()
        }
      >
        Joindre le document
      </button>
    </>
  )
}

export default UploadButton
